import Flickity from 'flickity'
import {animateInViewport} from '../transition'

$('.media-carousel').each(function () {
  const $this = $(this)
  const $container = $this.closest('.carousel-container')

  const swiper = new Swiper(this, {
    navigation: {
      nextEl: $container.find('.carousel-next')[0],
      prevEl: $container.find('.carousel-previous')[0],
    },
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: $container.find('.carousel-pagination')[0],
      clickable: true, // makes bullets clickable
    },
  })

  $container.find('.carousel-buttons a').on('click', function (e) {
    e.preventDefault()

    $(this).addClass('active').siblings().removeClass('active')

    const index = +$(this).data('slide-index')
    if (!isNaN(index)) swiper.slideTo(index)
  })

  swiper.on('slideChange', function () {
    const activeIndex = swiper.activeIndex

    $container
      .find('.carousel-buttons a')
      .removeClass('active')
      .filter('[data-slide-index="' + activeIndex + '"]')
      .addClass('active')
  })
})

$('.intro-carousel').each(function () {
  const $this = $(this)
  const $container = $this.closest('.carousel-container')
  const totalSlides = $this.find('.swiper-slide').length
  const delay = 700

  const swiper = new Swiper(this, {
    grabCursor: false,
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: false,
    autoplay: {
      delay: delay,
      disableOnInteraction: true,
    },
    allowTouchMove: false,
    on: {
      slideChange: function () {
        if (swiper.activeIndex === totalSlides - 1) {
          swiper.autoplay.stop()

          endIntro(delay)
        }
      },
    },
  })

  if (totalSlides < 2) {
    endIntro(delay)
  }

  // On .close-intro click: stop, and add both classes immediately
  $('.close-intro').on('click', function () {
    swiper.autoplay.stop()
    $('html').addClass('slideshow-ended intro-ended')
  })
})

function endIntro(delay) {
  setTimeout(function () {
    $('html').addClass('slideshow-ended')
  }, delay)

  setTimeout(function () {
    $('html').addClass('intro-started')
  }, 300 + delay)

  setTimeout(function () {
    $('html').addClass('logo-started')
  }, 1200 + delay)

  setTimeout(function () {
    $('html').addClass('intro-ended')
  }, 2000 + delay)
}

$('.marquee').each(function () {
  const self = this
  const $this = $(this)

  const speed = Number($this.attr('data-speed')) || 1000

  const flkty = {
    init() {
      this.flkty = new Flickity(self, {
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        freeScroll: true,
        imagesLoaded: true,
      })
      this.flkty.x = 0
      this.autoplaySpeed = 70
      this.loop()
    },

    loop() {
      const now = Date.now()
      const elapsedMillis = now - (this.autoplayLastTimestamp || now)
      this.autoplayLastTimestamp = now
      this.flkty.x +=
        (((this.autoplaySpeed || 50) * elapsedMillis) / speed) * (this.autoplayDirection || -1)
      this.flkty.integratePhysics()
      this.flkty.settle(this.flkty.x)
      animateInViewport($this)
      window.requestAnimationFrame(this.loop.bind(this))
    },
  }

  flkty.init()

  setTimeout(function () {
    if (flkty.flkty) {
      flkty.flkty.resize()
    }
  }, 200)
})

$('.tab-carousel').each(function () {
  const $this = $(this)
  const $container = $this.closest('.carousel-container')

  const swiperConfig = {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'fade',
    fadeEffect: {crossFade: true},
    speed: 500,
    allowTouchMove: false,
    autoHeight: true,
    on: {
      init: function () {
        setTimeout(() => {
          this.updateAutoHeight(300)
        }, 10)
      },
      slideChangeTransitionEnd: function () {
        setTimeout(() => {
          this.updateAutoHeight(300)
        }, 10)
      },
    },
  }

  const swiper = new Swiper(this, swiperConfig)

  $container.find('.tab-carousel-navigation a').on('click', function (e) {
    let slideIndex = $(this).data('slide')

    $container.find('.tab-carousel-navigation a').removeClass('active')
    $container
      .find('.tab-carousel-navigation a[data-slide="' + slideIndex + '"]')
      .addClass('active')

    swiper.slideTo(slideIndex)
  })
})

$('.floor-carousel').each(function () {
  const $this = $(this)

  let swiper = new Swiper(this, {
    navigation: {
      nextEl: $this.closest('.carousel-container').find('.carousel-next')[0],
      prevEl: $this.closest('.carousel-container').find('.carousel-previous')[0],
    },
    grabCursor: false,
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    allowTouchMove: false,
    pagination: {
      el: $this.closest('.carousel-container').find('.floor-bullets')[0],
      clickable: true,
      renderBullet: function (index, className) {
        const title = $this
          .closest('.carousel-container')
          .find('.floor-slide')
          .eq(index)
          .attr('data-title')

        return (
          '<span class="rounded-none floor-bullet invisible-link w-full py-1 bg-transparent ' +
          className +
          '">' +
          title +
          '</span>'
        )
      },
    },
  })

  $this
    .closest('.floor-carousel-container')
    .find('.floor-bullet')
    .on('click', function () {
      toggleFloorOptions()
    })
})

$('.floor-toggle-button').on('click', function () {
  toggleFloorOptions()
})

function toggleFloorOptions() {
  $('.floor-toggle-options').slideToggle(300)
  $('.floor-toggle-options-container').toggleClass('bg-light-beige-2')
  $('.floor-toggle-button .icon').toggleClass('rotate-45')
}

$('.version-carousel').each(function () {
  const $this = $(this)

  let swiper = new Swiper(this, {
    loop: true,
    allowTouchMove: false,
    grabCursor: false,
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: $this.closest('.swiper-slide').find('.version-bullets')[0],
      clickable: true,
      renderBullet: function (index, className) {
        const title = $this
          .closest('.carousel-container')
          .find('.version-slide')
          .eq(index + 1)
          .attr('data-title')

        return (
          '<span class="version-bullet transition-all bg-white text-dark-red rounded-[4px] px-2 py-0.5 invisible-link paragraph-3 ' +
          className +
          '">' +
          title +
          '</span>'
        )
      },
    },
    on: {
      afterInit: function (swiper) {
        if ($(window).width() >= 1024) {
          const $container = $this.closest('.carousel-container')

          const floorNavHeight = $container.find('.floor-nav').outerHeight()
          const maxVersionNavHeight = Math.max(
            ...$this
              .closest('.carousel-container')
              .find('.version-nav')
              .map(function () {
                return $(this).outerHeight()
              })
              .get(),
          )
          const bulletsHeight = $container.find('.floor-bullets').outerHeight()

          const offset = floorNavHeight + maxVersionNavHeight + bulletsHeight

          $container.find('.version-carousel').css('margin-top', -offset + 'px')
          $container.find('.key-facts').css('margin-top', offset + 'px')
        } else {
          $container.find('.version-carousel').css('margin-top', '0px')
          $container.find('.key-facts').css('margin-top', '0px')
        }
      },
    },
  })
})
